import { LOGOUT_URL } from "./settings";

export function catchError(error: any): void {
    console.error("General JS Catch Error catch this: " + error.status, error);

    if(error.status === 401) {
        window.location.href = LOGOUT_URL;
    }
}